import Auth from './Auth';


const models = {
    auth:Auth,
}

export default models;